import { render } from "./LinkInstallationIssueCompleted.vue?vue&type=template&id=481a9c2c&scoped=true"
import script from "./LinkInstallationIssueCompleted.vue?vue&type=script&lang=js"
export * from "./LinkInstallationIssueCompleted.vue?vue&type=script&lang=js"

import "./LinkInstallationIssueCompleted.vue?vue&type=style&index=0&id=481a9c2c&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-481a9c2c"]])

export default __exports__